import Pill from './Pill'
import { rem } from 'polished'

export const PILL_HEIGHT = rem(24)

export default Pill
